export const baseTheme = [
  { key: '--root-color', value: '#282828' },
  { key: '--root-color-contrast', value: '#ffffff' },

  { key: '--color-primary-050', value: 'hsl(232, 34%, 99%)' },

  { key: '--color-secondary-050', value: 'hsl(214, 82%, 99%)' },

  { key: '--color-accent-050', value: 'hsl(270, 50%, 99%)' },

  { key: '--color-neutral-050', value: '#fafafa' },
  { key: '--color-neutral-100', value: '#f5f5f5' },
  { key: '--color-neutral-200', value: '#eeeeee' },
  { key: '--color-neutral-300', value: '#e0e0e0' },
  { key: '--color-neutral-400', value: '#bdbdbd' },
  { key: '--color-neutral-500', value: '#9e9e9e' },
  { key: '--color-neutral-600', value: '#757575' },
  { key: '--color-neutral-700', value: '#616161' },
  { key: '--color-neutral-800', value: '#424242' },
  { key: '--color-neutral-900', value: '#212121' },

  { key: '--color-surface-050', value: '#ffffff' },
  { key: '--color-surface-100', value: '#fafafa' },
  { key: '--color-surface-200', value: '#f5f5f5' },
  { key: '--color-surface-300', value: '#eeeeee' },
  { key: '--color-surface-400', value: '#e0e0e0' },
  { key: '--color-surface-500', value: '#bdbdbd' },
  { key: '--color-surface-600', value: '#9e9e9e' },
  { key: '--color-surface-700', value: '#757575' },
  { key: '--color-surface-800', value: '#616161' },
  { key: '--color-surface-900', value: '#424242' },

  { key: '--color-texture-050', value: '#ffffff' },
  { key: '--color-texture-100', value: '#ffffff' },
  { key: '--color-texture-200', value: '#FAF8F5' },
  { key: '--color-texture-300', value: '#F3F0ED' },
  { key: '--color-texture-400', value: '#E5E7EB' },
  { key: '--color-texture-500', value: '#a9adbb' },
  { key: '--color-texture-600', value: '#9597a1' },
  { key: '--color-texture-700', value: '#5B534A' },
  { key: '--color-texture-800', value: '#5B534A' },
  { key: '--color-texture-900', value: '#5B534A' },

  { key: '--color-success-050', value: 'hsl(162, 78%, 99%)' },
  { key: '--color-success-100', value: 'hsl(162, 78%, 85%)' },
  { key: '--color-success-200', value: 'hsl(162, 78%, 75%)' },
  { key: '--color-success-300', value: 'hsl(162, 78%, 65%)' },
  { key: '--color-success-400', value: 'hsl(162, 78%, 55%)' },
  { key: '--color-success-500', value: 'hsl(162, 78%, 38%)' },
  { key: '--color-success-600', value: 'hsl(162, 78%, 30%)' },
  { key: '--color-success-700', value: 'hsl(162, 78%, 20%)' },
  { key: '--color-success-800', value: 'hsl(162, 78%, 10%)' },
  { key: '--color-success-900', value: 'hsl(162, 78%, 05%)' },

  { key: '--color-info-050', value: 'hsl(203, 50%, 99%)' },
  { key: '--color-info-100', value: 'hsl(203, 50%, 90%)' },
  { key: '--color-info-200', value: 'hsl(203, 50%, 80%)' },
  { key: '--color-info-300', value: 'hsl(203, 50%, 70%)' },
  { key: '--color-info-400', value: 'hsl(203, 50%, 65%)' },
  { key: '--color-info-500', value: 'hsl(203, 50%, 60%)' },
  { key: '--color-info-600', value: 'hsl(203, 50%, 50%)' },
  { key: '--color-info-700', value: 'hsl(203, 50%, 40%)' },
  { key: '--color-info-800', value: 'hsl(203, 50%, 30%)' },
  { key: '--color-info-900', value: 'hsl(203, 50%, 20%)' },

  { key: '--color-warning-050', value: 'hsl(30, 90%, 99%)' },
  { key: '--color-warning-100', value: 'hsl(30, 90%, 90%)' },
  { key: '--color-warning-200', value: 'hsl(30, 90%, 80%)' },
  { key: '--color-warning-300', value: 'hsl(30, 90%, 70%)' },
  { key: '--color-warning-400', value: 'hsl(30, 90%, 65%)' },
  { key: '--color-warning-500', value: 'hsl(30, 90%, 60%)' },
  { key: '--color-warning-600', value: 'hsl(30, 90%, 50%)' },
  { key: '--color-warning-700', value: 'hsl(30, 90%, 40%)' },
  { key: '--color-warning-800', value: 'hsl(30, 90%, 30%)' },
  { key: '--color-warning-900', value: 'hsl(30, 90%, 20%)' },

  { key: '--color-danger-050', value: 'hsl(7, 63%, 99%)' },
  { key: '--color-danger-100', value: 'hsl(7, 63%, 90%)' },
  { key: '--color-danger-200', value: 'hsl(7, 63%, 80%)' },
  { key: '--color-danger-300', value: 'hsl(7, 63%, 70%)' },
  { key: '--color-danger-400', value: 'hsl(7, 63%, 60%)' },
  { key: '--color-danger-500', value: 'hsl(7, 63%, 50%)' },
  { key: '--color-danger-600', value: 'hsl(7, 63%, 40%)' },
  { key: '--color-danger-700', value: 'hsl(7, 63%, 30%)' },
  { key: '--color-danger-800', value: 'hsl(7, 63%, 20%)' },
  { key: '--color-danger-900', value: 'hsl(7, 63%, 10%)' },

  { key: '--color-growth-050', value: 'hsl(106, 50%, 99%)' },
  { key: '--color-growth-100', value: 'hsl(106, 50%, 90%)' },
  { key: '--color-growth-200', value: 'hsl(106, 50%, 80%)' },
  { key: '--color-growth-300', value: 'hsl(106, 50%, 70%)' },
  { key: '--color-growth-400', value: 'hsl(106, 50%, 65%)' },
  { key: '--color-growth-500', value: 'hsl(106, 50%, 60%)' },
  { key: '--color-growth-600', value: 'hsl(106, 50%, 50%)' },
  { key: '--color-growth-700', value: 'hsl(106, 50%, 40%)' },
  { key: '--color-growth-800', value: 'hsl(106, 50%, 30%)' },
  { key: '--color-growth-900', value: 'hsl(106, 50%, 20%)' },

  { key: '--color-decline-050', value: 'hsl(7, 63%, 99%)' },
  { key: '--color-decline-100', value: 'hsl(7, 63%, 90%)' },
  { key: '--color-decline-200', value: 'hsl(7, 63%, 80%)' },
  { key: '--color-decline-300', value: 'hsl(7, 63%, 70%)' },
  { key: '--color-decline-400', value: 'hsl(7, 63%, 60%)' },
  { key: '--color-decline-500', value: 'hsl(7, 63%, 50%)' },
  { key: '--color-decline-600', value: 'hsl(7, 63%, 40%)' },
  { key: '--color-decline-700', value: 'hsl(7, 63%, 30%)' },
  { key: '--color-decline-800', value: 'hsl(7, 63%, 20%)' },
  { key: '--color-decline-900', value: 'hsl(7, 63%, 10%)' },

  { key: '--color-contrast-primary-050', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-100', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-200', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-300', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-secondary-050', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-100', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-200', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-300', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-accent-050', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-100', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-200', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-300', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-neutral-050', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-100', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-200', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-300', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-400', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-surface-050', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-100', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-200', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-300', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-400', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-500', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-600', value: 'var(--root-color)' },
  { key: '--color-contrast-surface-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-texture-050', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-100', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-200', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-300', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-400', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-500', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-600', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-700', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-800', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-900', value: 'var(--root-color)' },

  { key: '--color-contrast-success-050', value: 'var(--root-color)' },
  { key: '--color-contrast-success-100', value: 'var(--root-color)' },
  { key: '--color-contrast-success-200', value: 'var(--root-color)' },
  { key: '--color-contrast-success-300', value: 'var(--root-color)' },
  { key: '--color-contrast-success-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-info-050', value: 'var(--root-color)' },
  { key: '--color-contrast-info-100', value: 'var(--root-color)' },
  { key: '--color-contrast-info-200', value: 'var(--root-color)' },
  { key: '--color-contrast-info-300', value: 'var(--root-color)' },
  { key: '--color-contrast-info-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-warning-050', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-100', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-200', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-300', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-danger-050', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-100', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-200', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-growth-050', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-100', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-200', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-300', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-400', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-decline-050', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-100', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-200', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-900', value: 'var(--root-color-contrast)' },

  { key: '--root-bg-color', value: 'var(--color-surface-050)' },
  { key: '--text-color-main', value: '#282828' },
  { key: '--text-color-disabled', value: 'var(--color-neutral-400)' },
  { key: '--root-color', value: '#282828' },
  { key: '--theme-color-text-primary', value: 'var(--color-primary-500)' },
  { key: '--theme-color-link-hover', value: 'var(--color-accent-500)' },
  { key: '--surface-default-default-bg', value: 'var(--color-neutral-050)' },
  { key: '--surface-default-disabled-bg', value: 'var(--color-neutral-050)' },
  { key: '--theme-color-link-hover', value: 'var(--color-accent-500)' },

  { key: '--root-bg-color', value: 'var(--color-surface-050)' },
  { key: '--theme-color-divider', value: 'var(--color-neutral-200)' },
  { key: '--theme-color-border-normal', value: 'var(--color-neutral-200)' },
  { key: '--theme-color-border-selected', value: 'var(--color-neutral-500)' },
  { key: '--card-bg-color', value: 'var(--color-surface-050)' },

  { key: '--background-default-color-1', value: '#c8d1ff' },
  { key: '--background-default-color-2', value: '#c6c8e3' },

  // Fonts
  { key: '--font-serif', value: '"Gelasio", serif' },
  // { key: '--font-serif', value: '"Forum", serif' },
  // { key: '--font-serif', value: '"EB Garamond", serif' },
  { key: '--root-font', value: 'GothamPro,Gotham-Book,"Open Sans",Tahoma,"Segoe UI",sans-serif' },
  { key: '--font-sans', value: 'GothamPro,Gotham-Book,"Open Sans",Tahoma,"Segoe UI",sans-serif' },

  { key: '--tc-layout-text-color', value: 'var(--text-color-main)' },
  { key: '--tc-layout-accent-color', value: 'var(--color-primary-500)' },
  { key: '--tc-layout-app-bar-bg', value: 'var(--color-surface-050)' },

  // Denali AI
  { key: '--dai-color-bg', value: 'var(--color-texture-200)' },
  { key: '--dai-color-negative', value: 'var(--color-texture-050)' },
  { key: '--dai-color-surface1', value: 'var(--color-texture-200)' },
  { key: '--dai-color-surface2', value: 'var(--color-texture-300)' },
  { key: '--dai-color-surface3', value: 'var(--color-texture-300)' },
  { key: '--dai-color-surface4', value: 'var(--color-neutral-100)' },
  { key: '--dai-color-surface-highlight', value: 'color-mix(in srgb, var(--color-texture-100) 50%, var(--color-ai-100))' },
  { key: '--dai-color-bg-inline', value: 'var(--color-neutral-050)' },
  { key: '--dai-color-active', value: 'var(--color-ai-400)' },
  { key: '--dai-contrast-active', value: 'var(--color-contrast-ai-400)' },
  { key: '--dai-color-highlight', value: 'var(--color-ai-400)' },
  { key: '--dai-contrast-highlight', value: 'var(--color-contrast-ai-400)' },
  { key: '--dai-color-hover', value: 'var(--color-ai-100)' },
  { key: '--dai-contrast-hover', value: 'var(--color-contrast-ai-100)' },
  { key: '--dai-color-text', value: 'var(--text-color-main)' },
  { key: '--dai-color-accent', value: 'var(--color-ai-500)' },
  { key: '--dai-contrast-accent', value: 'var(--color-contrast-ai-500)' },
  { key: '--dai-color-accent-low', value: 'var(--color-ai-300)' },
  { key: '--dai-color-border1', value: 'var(--color-neutral-300)' },
  { key: '--dai-color-border-accent', value: 'var(--color-ai-200)' },
  { key: '--dai-color-border-accent-hl', value: 'var(--color-ai-500)' },
  { key: '--dai-color-input', value: 'white' },
  { key: '--dai-contrast-input', value: 'var(--dai-color-text)' },
  { key: '--dai-color-notify', value: 'var(--color-ai-500)' },
  { key: '--dai-color-notify-border', value: 'var(--color-ai-600)' },
  { key: '--dai-contrast-notify', value: 'var(--color-contrast-ai-500)' },
  { key: '--dai-bg-nav', value: 'var(--dai-color-surface3)' },
  { key: '--dai-color-icon-button', value: 'var(--color-neutral-400)' },
  { key: '--dai-color-icon-button-hover', value: 'var(--color-neutral-600)' },

  { key: '--dai-border1', value: '1px solid var(--dai-color-border1)' },
  { key: '--dai-border-2', value: '1px solid color-mix(in srgb, var(--dai-color-text) 25%, transparent)' },
  { key: '--dai-border-accent', value: '2.5px solid var(--dai-color-border-accent)' },
  { key: '--dai-bg', value: 'radial-gradient(circle, var(--dai-color-bg), var(--dai-color-bg) 85%, var(--dai-color-negative))' },
  { key: '--dai-color-text-low', value: 'color-mix(in srgb, var(--dai-color-text) 50%, transparent)' },
  { key: '--dai-color-text-dim', value: 'color-mix(in srgb, var(--dai-color-text) 25%, transparent)' }

]

baseTheme.$type = 'light'
